<template>
  <div class="bluefire-wap-wrap rm-page">
    <!-- 顶部栏：与 h5/tools 保持一致的移动端头部 -->
    <wap-header
      header-text="资源列表"
      :header-visible="true"
      :back-visible="true"
      :user-list-lock.sync="userListLock" /><!--参数都可以不传-->

    <div class="rm-body">

      <!-- 查询条件 -->
      <div class="rm-card rl-filter">
        <div class="rl-filter-bar">
          <el-button class="rl-filter-toggle" size="small" @click="filterExpanded = !filterExpanded">
            {{ filterExpanded ? '收起筛选' : '展开筛选' }}
          </el-button>
          <el-button class="rl-new" size="small" @click="goNew">新建</el-button>
        </div>

        <el-form
          v-show="filterExpanded"
          class="rm-form"
          label-position="left"
          label-width="80px"
          @submit.native.prevent>
          <div class="rm-grid">

            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">客户编码</span>
              <el-input
                v-model.trim="searchData.id"
                placeholder="请输入客户编码"
                clearable
                @keyup.enter.native="search" />
            </el-form-item>

            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">姓名</span>
              <el-input
                v-model.trim="searchData.username"
                placeholder="请输入姓名"
                clearable
                @keyup.enter.native="search" />
            </el-form-item>

            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">电话</span>
              <el-input
                v-model.trim="searchData.tel"
                placeholder="请输入手机号"
                type="tel"
                clearable
                @keyup.enter.native="search" />
            </el-form-item>

            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">微信</span>
              <el-input
                v-model.trim="searchData.wechat"
                placeholder="请输入微信号"
                clearable
                @keyup.enter.native="search" />
            </el-form-item>

            <el-form-item class="rm-item">
              <span slot="label" class="rm-label">QQ</span>
              <el-input
                v-model.trim="searchData.qq"
                placeholder="请输入 QQ 号"
                type="tel"
                :maxlength="20"
                clearable
                @keyup.enter.native="search" />
            </el-form-item>

            <!-- 渠道来源：五级联动，单列纵向铺开，与上方输入框等长 -->
            <el-form-item class="rm-item rm-item--top">
              <span slot="label" class="rm-label">渠道来源</span>
              <jm-channel
                :key="channelKey"
                v-model="searchData.channels"
                :is-all="false"
                clearable
                filter />
            </el-form-item>

          </div>

          <div class="rl-filter-btns">
            <el-button class="rl-btn" @click="resetSearch">重置</el-button>
            <el-button class="rl-btn" type="primary" :loading="loading" @click="search">查询</el-button>
          </div>
        </el-form>
      </div>

      <!-- 列表 -->
      <div v-loading="loading" class="rm-card rl-card">
        <div class="rl-list">
          <div class="rl-head">
            <span>客户编码</span>
            <span>姓名</span>
            <span>电话</span>
            <span>微信</span>
            <span>QQ</span>
            <span>渠道</span>
            <span>创建日期</span>
            <span>操作</span>
          </div>

          <div
            v-for="row in list"
            :key="row.id"
            class="rl-row">
            <div class="rl-cell">
              <i class="rl-cell__label">客户编码</i>
              <div class="rl-cell__value">
                <span class="rl-cell__text">{{ row.id || '-' }}</span>
                <Copy v-if="row.id" :content="String(row.id)" @copyCallback="copyClick">
                  <el-button class="rl-copy" size="mini">复制</el-button>
                </Copy>
              </div>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">姓名</i>
              <span class="rl-cell__value">{{ row.username || row.nickname ? [row.username, row.nickname].filter(Boolean).join(' / ') : '-' }}</span>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">电话</i>
              <div class="rl-cell__value">
                <span class="rl-cell__text">{{ row.tel || '-' }}</span>
                <Copy v-if="row.tel" :content="row.tel" @copyCallback="copyClick">
                  <el-button class="rl-copy" size="mini">复制</el-button>
                </Copy>
              </div>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">QQ</i>
              <span class="rl-cell__value">{{ row.qq || '-' }}</span>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">微信</i>
              <div class="rl-cell__value">
                <span class="rl-cell__text">{{ row.wechat || '-' }}</span>
                <Copy v-if="row.wechat" :content="row.wechat" @copyCallback="copyClick">
                  <el-button class="rl-copy" size="mini">复制</el-button>
                </Copy>
              </div>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">渠道</i>
              <span class="rl-cell__value rl-cell__value--channel">{{ formatChannel(row) || '-' }}</span>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">创建日期</i>
              <span class="rl-cell__value rl-cell__value--date">{{ row.create_time }}</span>
            </div>
            <div class="rl-cell">
              <i class="rl-cell__label">创建人</i>
              <span class="rl-cell__value rl-cell__value--date">{{ row.creator_name || row.creator || row.creator_uid || '-' }}</span>
            </div>
            <div class="rl-cell rl-cell--ops">
              <i class="rl-cell__label">操作</i>
              <div class="rl-cell__value">
                <el-button class="rl-edit" type="primary" size="mini" @click="goEdit(row)">编辑</el-button>
              </div>
            </div>
          </div>

          <div v-if="!loading && !list.length" class="rl-empty">暂无数据</div>
        </div>

        <el-pagination
          v-if="total > 0"
          class="rl-pagination"
          layout="prev, next, total"
          :current-page.sync="page"
          :page-size="pageSize"
          :total="total"
          @current-change="fetchList" />
      </div>

    </div>
  </div>
</template>

<script>
import header from './compoments/header';
import { jmChannel } from '@/components/tool';
import { getChannelDataset } from '@/utils/utils';

const emptyChannel = () => ({
  custom_from: '',
  custom_from_sub: '',
  custom_from_thrid: '',
  custom_from_fourth: '',
  custom_from_fifth: '',
});

const emptySearch = () => ({
  id: '',
  username: '',
  tel: '',
  wechat: '',
  qq: '',
  channels: emptyChannel(),
});

export default {
  name: 'ResourceMobileList',
  components: {
    'wap-header': header,
    jmChannel,
  },
  data() {
    return {
      userListLock: true, // 头部账号列表锁，由 wap-header 通过 .sync 更新
      loading: false,
      filterExpanded: false, // 手机默认收起筛选，点击按钮展开
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      channelKey: 0,
      channelDataset: [], // 渠道字典，用于把渠道 ID 渲染成文本
      searchData: emptySearch(),
    };
  },
  computed: {
    listUrl() {
      return '/training/customer/pagetableLite';
    },
  },
  created() {
    // 渠道字典（带 Lockr 缓存），列表里把渠道 ID 渲染成文本用
    getChannelDataset().then(({ channels }) => {
      this.channelDataset = channels || [];
    });
    this.fetchList(1);
  },
  methods: {
    /**
     * 拉取列表，请求方式与 jm-tableList 保持一致
     * POST {url}?page=N，body: { pageSize, amount, sortData, searchData }
     */
    fetchList(page = 1) {
      this.loading = true;
      this.$http._post({
        url: `${this.listUrl}?page=${page}`,
        data: {
          pageSize: this.pageSize,
          amount: this.total,
          sortData: {},
          searchData: { ...this.searchData },
        },
      }).then(({ data }) => {
        this.list = data.data || [];
        this.total = data.total || 0;
        this.page = page;
        this.loading = false;
      }).catch(() => {
        this.list = [];
        this.loading = false;
      });
    },
    /**
     * 查询：回到第一页
     */
    search() {
      this.fetchList(1);
    },
    /**
     * 重置查询条件，并强制重建渠道组件清空子级选项
     */
    resetSearch() {
      this.searchData = emptySearch();
      this.channelKey += 1;
      this.fetchList(1);
    },
    /**
     * 渠道展示
     */
    formatChannel(row) {
      if (typeof row.custom_from === 'string' && row.custom_from.trim()) {
        return row.custom_from.trim().split(/\s+/).join(' / ');
      }
    },
    goEdit(row) {
      this.$router.push({ name: 'mobileEditCustomer', params: { id: row.id } });
    },
    copyClick() {
      this.$message.success('复制成功');
    },
    goNew() {
      this.$router.push({ name: 'mobileAddCustomer' });
    },
  },
};
</script>

<style scoped>
/* 外层用 h5 通用的 bluefire-wap-wrap（全局样式：padding-top 8vh 让位固定头部） */
.rm-page {
  -webkit-text-size-adjust: 100%;
}

.rm-body {
  padding: 14px 14px 24px;
}

.rm-card {
  padding: 4px 16px 12px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.rm-grid {
  display: grid;
  grid-template-columns: 1fr; /* 手机：单列 */
  gap: 0;
}

.rm-item {
  margin-bottom: 0;
}

.rm-item--full {
  grid-column: 1 / -1;
}

.rm-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}

/* 筛选开关 */
.rl-filter {
  margin-bottom: 14px;
}

/* 展开/收起筛选 + 新建：同一行，两端分布 */
.rl-filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  margin-top: 14px;
}

.rl-filter-toggle {
  height: 36px;
  padding: 0 16px;
  border-radius: 18px;
  font-size: 14px;
}

.rl-new {
  flex: none;
  height: 36px;
  padding: 0 18px;
  border-radius: 18px;
  font-size: 14px;
  background-color: #67c23a; /* 绿色：新增语义，区别于查询的蓝色 */
  border-color: #67c23a;
  color: #fff;
}

.rl-new:hover,
.rl-new:focus {
  background-color: #85ce61;
  border-color: #85ce61;
  color: #fff;
}

.rl-new:active {
  background-color: #5daf34;
  border-color: #5daf34;
  color: #fff;
}

.rl-filter-btns {
  display: flex;
  margin-top: 6px;
}

.rl-btn {
  flex: 1;
  height: 46px;
  font-size: 16px;
  border-radius: 10px;
}

.rl-btn + .rl-btn {
  margin-left: 12px;
}

/* ===== 列表：手机卡片流（不再兼容 PC 表格形态） ===== */
.rl-card {
  padding: 4px 16px 12px;
}

.rl-head {
  display: none;
}

.rl-row {
  display: block;
  padding: 12px 0 8px;
  border-bottom: 1px solid #f2f3f5;
}

.rl-row:last-of-type {
  border-bottom: none;
}

.rl-cell {
  display: flex;
  align-items: center;
  padding: 4px 0;
  font-size: 15px;
  line-height: 22px;
}

.rl-cell__label {
  flex: none;
  width: 76px;
  margin-right: 8px;
  font-size: 13px;
  font-style: normal;
  color: #909399;
}

.rl-cell__value {
  display: flex;
  align-items: center;
  flex: 1;
  color: #303133;
  word-break: break-all;
}

.rl-cell__text {
  flex: 1;
}

/* 复制 / 编辑：统一按钮样式，触控友好 */
.rl-copy,
.rl-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  height: 32px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 1;
}

.rl-copy {
  margin-left: 8px;
}

/* vue-to-copy 渲染为块级 div.copy，放入 flex 容器需重置 */
.rl-cell__value .copy {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.rl-cell--ops .rl-cell__value {
  justify-content: flex-end;
}

.rl-cell__value--channel {
  color: #606266;
}

.rl-cell__value--date {
  color: #909399;
}

.rl-empty {
  padding: 48px 0;
  font-size: 14px;
  color: #909399;
  text-align: center;
}

/* ===== 分页：手机友好 ===== */
/* 一行排列：上一页 / 下一页 / 总条数（顺序由 layout 决定，无数字导航） */
.rl-pagination {
  display: flex;
  align-items: center; /* 纵向居中：整块分页在栏内垂直居中 */
  justify-content: center; /* 横向居中：整块分页在页面水平居中 */
  min-height: 52px; /* 给垂直居中一个明确的高度参考 */
  padding: 16px 12px calc(16px + env(safe-area-inset-bottom));
}

.rl-pagination /deep/ .el-pagination {
  display: flex;
  flex-wrap: wrap; /* 极窄屏兜底，正常一行 */
  align-items: center; /* 内部三项（上一页/下一页/总条数）纵向居中对齐 */
  justify-content: center; /* 内部三项横向居中 */
  width: 100%;
}

.rl-pagination /deep/ .el-pagination__total {
  margin: 0 0 0 6px;
  font-size: 13px;
  color: #909399;
}

/* 上一页 / 下一页 统一为带边框背景的按钮样式，手机上明确可点 */
.rl-pagination /deep/ .btn-prev,
.rl-pagination /deep/ .btn-next {
  box-sizing: border-box;
  min-width: 36px;
  height: 36px;
  line-height: 34px; /* 34 = 36 - 上下边框各 1px，保持文字垂直居中 */
  margin: 0 3px;
  padding: 0 8px;
  font-size: 14px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  color: #606266;
}

/* 上一页 / 下一页 为汉字，需更宽 */
.rl-pagination /deep/ .btn-prev,
.rl-pagination /deep/ .btn-next {
  min-width: 60px;
}

/* 可点状态 hover：高亮边框与文字 */
.rl-pagination /deep/ .btn-prev:hover:not(:disabled),
.rl-pagination /deep/ .btn-next:hover:not(:disabled) {
  color: #409eff;
  border-color: #409eff;
}

/* 禁用态（首/末页时）：灰底灰字，明确不可点 */
.rl-pagination /deep/ .btn-prev:disabled,
.rl-pagination /deep/ .btn-next:disabled {
  color: #c0c4cc;
  background: #f5f7fa;
  border-color: #ebeef5;
  cursor: not-allowed;
}

/* element-ui 结构微调：label 与控件同一行 */
.rm-form /deep/ .el-form-item {
  margin-bottom: 0;
  padding: 11px 0;
  border-bottom: 1px solid #f2f3f5;
}

.rm-form /deep/ .el-form-item:last-child {
  border-bottom: none;
}

.rm-form /deep/ .el-form-item__label {
  float: left;
  padding: 0 12px 0 0;
  line-height: 46px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  text-align: left;
  white-space: nowrap;
}

.rm-form /deep/ .el-form-item__content {
  line-height: 46px;
}

.rm-form /deep/ .rm-item--top .el-form-item__label {
  line-height: 24px;
  padding-top: 11px;
}

.rm-form /deep/ .el-input__inner {
  height: 46px;
  font-size: 16px; /* 防止 iOS 聚焦时自动放大 */
}

/* 渠道五级联动：纵向铺满，与上方输入框等长 */
.rm-form /deep/ .jm-channel-select {
  display: block;
  width: 100%;
}

.rm-form /deep/ .jm-channel-select .el-select {
  display: block;
  width: 100% !important;
  margin: 0 0 10px;
}

.rm-form /deep/ .jm-channel-select .el-select .el-input__inner {
  height: 44px;
}
</style>
